import { createRouter, createWebHistory } from 'vue-router'
import NotFound from '../pages/common/error/not-found.vue'
import PageIndex from '@/pages/index.vue'
import { redirectToLogin } from '@/common/common-fn'
import { getAuthToken } from '@/utils/auth'
import { logout } from '@/views/pages/account/common/common-function'
import { nextTick } from 'vue'
import { setTitle, TitleConst } from '../utils/context-data'
import Enumeration from '@/common/enumeration.js'
const routes = [
  // Account routes

  {
    path: '/account',
    alias: '/',
    name: 'Account',
    component: PageIndex,
    meta: {
      ignoreAuth: true
    },
    redirect: '/account/login',
    children: [
      {
        path: 'register-account-student',
        name: 'RegisterStudentAccount',
        meta: {
          ignoreAuth: true,
          notRedirect: true
        },
        component: () =>
          import(
            /* webpackChunkName: "register" */ '../pages/account/chose-student-join-class'
          )
      },
      {
        path: 'logout',
        name: 'Logout',
        meta: {
          notRedirect: true,
          ignoreAuth: true
        },
        beforeEnter () {
          logout()
        }
      },
      {
        path: 'login',
        name: 'AccountLogin',
        component: () =>
          import(/* webpackChunkName: "login" */ '../pages/account/login'),
        meta: {
          ignoreAuth: true
        }
      },
      {
        path: 'register',
        name: 'AccountRegister',
        component: () =>
          import(
            /* webpackChunkName: "register" */ '../pages/account/register'
          ),
        meta: {
          ignoreAuth: true
        }
      },
      {
        path: 'register-experience',
        name: 'RegisterExperience',
        component: () =>
          import(
            /* webpackChunkName: "register-experience" */ '../pages/account/register-experience'
          ),
        meta: {
          ignoreAuth: true
        }
      },
      {
        path: 'forget-password',
        props: true,
        name: 'AccountForgetPassword',
        component: () =>
          import(
            /* webpackChunkName: "forget-password" */ '../pages/account/forget-password'
          ),
        meta: {
          ignoreAuth: true
        }
      },
      {
        path: 'change-password',
        props: true,
        name: 'AccountChangePassword',
        component: () =>
          import(
            /* webpackChunkName: "forget-password" */ '../pages/account/change-password'
          ),
        meta: {
          ignoreAuth: true
        }
      },
      {
        path: 'join-class',
        props: true,
        name: 'AccountJoinClass',
        component: () =>
          import(
            /* webpackChunkName: "forget-password" */ '../pages/account/join-class'
          ),
        meta: {
          ignoreAuth: true
        }
      },
      {
        path: 'has-account',
        props: true,
        name: 'HaAccount',
        component: () =>
          import(
            /* webpackChunkName: "has-account" */ '../pages/account/has-account'
          ),
        meta: {
          ignoreAuth: true
        }
      },
      {
        path: 'active',
        props: true,
        name: 'AccountActive',
        component: () =>
          import(
            /* webpackChunkName: "account-active" */ '../pages/account/active'
          ),
        meta: {
          ignoreAuth: true
        }
      },
      {
        path: 'login-via-token',
        name: 'LoginViaToken',
        component: () =>
          import(
            /* webpackChunkName: "login" */ '../pages/account/login-via-token'
          ),
        meta: {
          ignoreAuth: true,
          notRedirect: true
        }
      },
      {
        path: 'login-external',
        name: 'LoginExternal',
        component: () =>
          import(
            /* webpackChunkName: "login-external" */ '../pages/account/login-external'
          ),
        meta: {
          ignoreAuth: true
        }
      },

      {
        path: 'secret',
        name: 'AccountSecret',
        component: () =>
          import(
            /* webpackChunkName: "login-external" */ '../pages/account/secret'
          ),
        meta: {
          ignoreAuth: true
        }
      }
    ]
  },

  // Teacher routes
  {
    path: '/teacher',
    name: 'Teacher',
    component: PageIndex,
    redirect (to) {
      return {
        path: `${to.path}/dashboard`
      }
    },
    children: [

      {
        path: 'ranking-game',
        name: 'RankingGame',
        component: () =>
          import(
            /* webpackChunkName: "ranking-game" */ '@/pages/teacher/classroom/id/exercise/correcting/ranking-game.vue'
          )
      },
      // Tổng quan
      {
        path: 'dashboard',
        // alias: '',
        name: 'DashBoard',
        component: () =>
          import(
            /* webpackChunkName: "document" */ '@/pages/teacher/dashboard'
          ),
        meta: {
          helpID: '17852'
        },
        children: [
          {
            path: '',
            name: 'DashboardOverview',
            meta: {
              groupType: 'DashBoard',
              bussinessType: 'DashBoard_OverView'
            },
            component: () =>
              import(
                /* webpackChunkName: "dashboard-overview" */ '@/pages/teacher/dashboard/overview'
              )
          },
          {
            path: 'detail/:classCode',
            name: 'DashboardOverviewDetail',
            meta: {
              groupType: 'DashBoard',
              bussinessType: 'DashBoard_Detail'
            },
            component: () =>
              import(
                /* webpackChunkName: "dashboard-overview-detail" */ '@/pages/teacher/dashboard/detail'
              )
          },
          {
            path: ':classCode',
            name: 'TeacherClassDetail1',
            component: () =>
              import(
                /* webpackChunkName: "class-detail1" */ '@/pages/teacher/classroom/id'
              ),
            redirect: (to) => {
              return {
                path: `${to.path}/exercise`
              }
            },
            props: true,
            children: [
              {
                path: 'exercise',
                name: 'TeacherClassroomExercise1',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "exercise-list" */ '@/pages/teacher/classroom/id/exercise'
                  ),
                redirect: '',
                children: [
                  {
                    path: ':exerciseID',
                    name: 'ExerciseDetail1',
                    meta: {
                      excludeSidebar: true
                    },
                    props: true,
                    component: () =>
                      import(
                        /* webpackChunkName: "exercisedetail1" */ '@/pages/teacher/classroom/id/exercise/detail'
                      )
                  }
                ]
              }
            ]
          },
          {
            path: 'log-activity-teacher',
            name: 'LogActivityTeacher',
            component: () =>
              import(
                /* webpackChunkName: "log-activity-teacher" */ '@/pages/teacher/dashboard/log-activity-teacher'
              )
          },
          {
            path: 'link-setup',
            name: 'LinkSetup',
            component: () =>
              import(
                /* webpackChunkName: "link-setup" */ '@/pages/teacher/dashboard/link-setup'
              )
          }
        ]
      },

      // màn hình kho học liệu
      {
        path: 'storage', // Màn hình kho - CreateBy: NVDuc 17/05/2021
        name: 'Storage',
        component: () =>
          import(/* webpackChunkName: "storage" */ '@/pages/teacher/storage'),

        children: [
          {
            path: 'preview',
            name: 'Preview',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "preview" */ '@/pages/teacher/storage/preview'
              )
          },
          {
            path: '',
            name: 'StorageList',
            meta: {
              // groupType: 'DocumentStore',
              // bussinessType: 'DocumentStore_List',
              helpID: '16514'
            },
            redirect: `/teacher/storage/mine/${Enumeration.ExerciseStoreType.MyPost}`,
            component: () =>
              import(
                /* webpackChunkName: "storage-list" */ '@/pages/teacher/storage/list'
              ),

            children: [
              // Router học liệu của tôi
              {
                path: 'mine/:sourceType',
                name: 'StorageMine',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "storage-mine" */ '@/pages/teacher/storage/list/mine'
                  )
              },
              // Router chia sẻ trong trường
              {
                path: 'share-school/:sourceType',
                name: 'StorageShareSchool',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "storage-share-school" */ '@/pages/teacher/storage/list/share-school'
                  )
              },
              // Router môn học của chia sẻ trong trường
              {
                path: 'share-school/:sourceType/:sourceCategory',
                name: 'StorageShareSchoolSubject',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "storage-share-school-subject" */ '@/pages/teacher/storage/list/share-school/subject'
                  )
              },
              // Router cộng đồng giáo viên
              {
                path: 'commonity/:sourceType',
                name: 'StorageCommonity',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "storage-commonity" */ '@/pages/teacher/storage/list/commonity'
                  )
              },
              // Router Danh sách yêu thích của cộng đồng giáo viên
              {
                path: 'commonity/:sourceType/:favorite',
                name: 'StorageCommonityFavorite',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "storage-commonity-favorite" */ '@/pages/teacher/storage/list/commonity/favorite'
                  )
              }

            ]
          },
          {
            path: 'create',
            name: 'StorageCreate',
            meta: { excludeHeader: true },
            component: () =>
              import(
                /* webpackChunkName: "storage-create" */ '@/pages/teacher/storage/create'
              )
          },
          {
            path: 'createv2',
            name: 'StorageCreateV2',
            meta: { excludeHeader: true },
            component: () =>
              import(
                /* webpackChunkName: "storage-createv2" */ '@/pages/teacher/storage/create-v2'
              )
          },
          {
            path: 'storageitem',
            name: 'StorageItem',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "storage-id1313" */ '@/pages/teacher/storage/storageitem'
              ),
            meta: {
              excludeHeader: true,
              groupType: 'DocumentStore',
              bussinessType: 'DocumentStore_Detail'
            }
          },

          {
            path: 'try-created-exercise/:id/:actionType',
            name: 'TryCreatedExercise',
            component: () =>
              import(
                /* webpackChunkName: "try-created-exercises" */ '@/pages/teacher/storage/exercises/try-created-exercises/try-exercise'
              ),
            meta: {
              excludeHeader: true,
              groupType: 'DocumentStore',
              bussinessType: 'DocumentStore_TryLearning'
            }
          },

          {
            path: 'theme',
            name: 'TeacherChooseTheme',
            component: () =>
              import(
                /* webpackChunkName: "teacher-choose-theme" */ '@/pages/teacher/storage/exercises/try-created-exercises-v2/choose-theme'
              ),
            meta: { excludeHeader: true }
          },

          {
            path: 'try-created-exercisev2',
            name: 'TryCreatedExerciseV2',
            component: () =>
              import(
                /* webpackChunkName: "try-created-exercisesv2" */ '@/pages/teacher/storage/exercises/try-created-exercises-v2/try-exercise'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'answer-overviewv2',
            name: 'AnswerOverViewV2',
            component: () =>
              import(
                /* webpackChunkName: "answer-overviewv2" */ '@/pages/teacher/storage/exercises/try-created-exercises-v2/answer-overview'
              ),
            meta: { excludeHeader: true }
          },

          {
            path: 'watch-upload-exercise/:id/:actionType/:editMode',
            name: 'WatchUploadExercise',
            component: () =>
              import(
                /* webpackChunkName: "watch-upload-exercises" */ '@/pages/teacher/storage/exercises/try-upload-exercises/watch-exercise'
              ),
            meta: {
              excludeHeader: true,
              groupType: 'DocumentStore',
              bussinessType: 'DocumentStore_TryLearning'
            }
          },

          {
            path: 'try-upload-exercise/:id/:actionType/:editMode/:source',
            name: 'TryUploadExercise',
            component: () =>
              import(
                /* webpackChunkName: "try-upload-exercises" */ '@/pages/teacher/storage/exercises/try-upload-exercises/try-exercise'
              ),
            meta: {
              excludeHeader: true,
              groupType: 'DocumentStore',
              bussinessType: 'DocumentStore_TryLearning'
            }
          },
          // Giao bài
          {
            path: 'assignment/:editMode',
            name: 'Assignment',
            component: () =>
              import(
                /* webpackChunkName: "assignment" */ '@/pages/teacher/assignment'
              ),
            children: [
              {
                path: '',
                name: 'ExerciseAssignment',
                meta: {
                  groupType: 'Teaching',
                  bussinessType: 'Teaching_GiveExcercise',
                  excludeHeader: true,
                  helpID: '16495'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "exercise-assignment" */ '@/pages/teacher/assignment/exercise'
                  )
              },
              {
                path: 'composed',
                name: 'ComposedExercise',
                meta: {
                  excludeHeader: true
                },
                component: () =>
                  import(
                    /* webpackChunkName: "composed-exercise" */ '@/pages/teacher/assignment/composed-exercise'
                  )
              }
            ]
          },

          // Thư viện
          {
            path: 'library-list',
            name: 'LibraryList',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "library-list" */ '@/pages/teacher/storage/library-list'
              )
          },

          // Chia sẻ
          {
            path: 'share',
            name: 'Share',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "share" */ '@/pages/teacher/storage/share'
              )
          },

          // Làm thử dạng game
          {
            path: 'try-game/:exerciseId',
            name: 'TryGame',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "share" */ '@/pages/teacher/storage/exercises/try-game-exercise'
              )
          }
        ]
      },

      // Lớp học
      {
        path: 'classroom',
        name: 'TeacherClassoom',
        component: () =>
          import(
            /* webpackChunkName: "classroom" */ '@/pages/teacher/classroom'
          ),
        children: [
          {
            path: 'storageitem',
            name: 'TeacherClassoomStorageItem',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "storage-id" */ '@/pages/teacher/storage/storageitem'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: '',
            name: 'TeacherClassList',
            meta: {
              groupType: 'Teaching',
              bussinessType: 'Teaching_Classroom',
              helpID: '16474'
            },
            component: () =>
              import(
                /* webpackChunkName: "class-list" */ '@/pages/teacher/classroom/list/active-classroom.vue'
              )
          },
          {
            path: 'inactive-classroom',
            name: 'InactiveClassroom',
            component: () =>
              import(
                /* webpackChunkName: "inactive-classroom" */ '@/pages/teacher/classroom/list/inactive-classroom.vue'
              )
          },
          {
            path: ':classCode',
            name: 'TeacherClassDetail',
            component: () =>
              import(
                /* webpackChunkName: "class-detail" */ '@/pages/teacher/classroom/id'
              ),
            redirect: (to) => {
              return {
                path: `${to.path}/exercise`
              }
            },
            props: true,
            children: [
              {
                path: 'teacher',
                name: 'TeacherTeacherList',
                props: true,
                meta: {
                  groupType: 'Teaching',
                  bussinessType: 'Teaching_Teacher'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "teacher-list" */ '@/pages/teacher/classroom/id/teacher'
                  )
              },
              {
                path: 'student',
                name: 'TeacherStudentList',
                props: true,
                meta: {
                  groupType: 'Teaching',
                  bussinessType: 'Teaching_Student',
                  helpID: '16478'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "student-list" */ '@/pages/teacher/classroom/id/student'
                  )
              },
              {
                path: 'news-feed',
                name: 'TeacherClassDetailNewsFeed',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "news-feed" */ '@/pages/teacher/classroom/id/news-feed'
                  )
              },
              {
                path: 'calendar',
                name: 'TeacherClassDetailCalendar',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "calendar-list" */ '@/pages/teacher/classroom/id/calendar'
                  )
              },
              {
                path: 'exercise',
                name: 'TeacherClassroomExercise',
                props: true,
                component: () =>
                  import(
                    /* webpackChunkName: "exercise-list" */ '@/pages/teacher/classroom/id/exercise'
                  ),
                redirect: '',
                children: [
                  {
                    path: '',
                    name: 'TeacherExerciseList',
                    props: true,
                    meta: {
                      groupType: 'Teaching',
                      bussinessType: 'Teaching_ExcerciseCard',
                      helpID: '16510'
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "student-exercise-list" */ '@/pages/teacher/classroom/id/exercise/list'
                      )
                  },
                  {
                    path: ':exerciseID',
                    name: 'ExerciseDetail',
                    meta: {
                      excludeSidebar: true
                    },
                    props: true,
                    component: () =>
                      import(
                        /* webpackChunkName: "exercisedetail" */ '@/pages/teacher/classroom/id/exercise/detail'
                      )
                  },
                  {
                    path: ':exerciseID/:submitExerciseID',
                    name: 'CorrectingExercise',
                    meta: {
                      excludeSidebar: true,
                      excludeHeader: true,
                      groupType: 'Teaching',
                      bussinessType: 'Teaching_ExcerciseDetail'
                    },
                    props: true,
                    component: () =>
                      import(
                        /* webpackChunkName: "correcting-exercise" */ '@/pages/teacher/classroom/id/exercise/correcting/index.vue'
                      ),
                    children: [
                      {
                        path: 'correcting',
                        name: 'TeacherCorrecting',
                        props: true,
                        meta: {
                          helpID: '19460'
                        },
                        component: () =>
                          import(
                            /* webpackChunkName: "teacher-correcting" */ '@/pages/teacher/classroom/id/exercise/correcting/correcting.vue'
                          )
                      },
                      {
                        path: '',
                        name: 'PreviewStudentAnswer',
                        props: true,
                        meta: {
                          helpID: '20841'
                        },
                        component: () =>
                          import(
                            /* webpackChunkName: "preview-student-answer" */ '@/pages/teacher/classroom/id/exercise/correcting/preview-student-answer.vue'
                          )
                      },
                      {
                        path: 'ranking-game',
                        name: 'RankingGame',
                        component: () =>
                          import(
                            /* webpackChunkName: "ranking-game" */ '@/pages/teacher/classroom/id/exercise/correcting/ranking-game.vue'
                          )
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            path: 'results',
            name: 'ExerciseResult',
            component: () =>
              import(
                /* webpackChunkName: "exercise-id" */ '@/pages/teacher/classroom/results'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'preview-answer-upload/:pagePrev/:classCode/:exerciseCardID/:submitExercisesID',
            name: 'TeacherPreviewAnswerUpload',
            component: () =>
              import(
                /* webpackChunkName: "preview-answer-upload-teacher" */ '@/pages/student/exercises/preview-answer-upload'
              ),
            meta: { excludeHeader: true }
          },

          // Giao bài
          {
            path: 'assignment/:editMode',
            name: 'ClassroomAssignment',
            component: () =>
              import(
                /* webpackChunkName: "classroom-assignment" */ '@/pages/teacher/assignment'
              ),
            children: [
              {
                path: '',
                name: 'ClassroomExerciseAssignment',
                component: () =>
                  import(
                    /* webpackChunkName: "classroom-exercise-assignment" */ '@/pages/teacher/assignment/exercise'
                  ),
                meta: { excludeHeader: true }
              }
            ]
          }
        ]
      },

      {
        path: 'training',
        name: 'Training',
        component: () =>
          import(
            /* webpackChunkName: "classroom" */ '@/pages/teacher/training'
          )
      },

      // Bài kiểm tra
      {
        path: 'exam-store',
        name: 'TeacherExamStore',
        component: () =>
          import(
            /* webpackChunkName: "teacher-exam-store" */ '@/pages/teacher/exam'
          ),
        meta: {
          title: TitleConst.Exam,
          isExam: true
        },
        children: [
          {
            path: '',
            name: 'TeacherExamList',
            meta: {
              // groupType: 'DocumentTest',
              // bussinessType: 'ExamSubject_List',
              helpID: '20256'
            },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-store-list" */ '@/pages/teacher/exam/list'
              )
          },
          {
            path: 'compose',
            name: 'TeacherExamCompose',
            meta: {
              excludeHeader: true,
              helpID: '20256'
            },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-store-compose" */ '@/pages/teacher/exam/compose'
              )
          },
          {
            path: ':examStoreID',
            name: 'TeacherExamDetail',
            meta: {
              excludeHeader: true,
              groupType: 'DocumentTest',
              bussinessType: 'ExamSubject_Detail'
            },
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-store-detail" */ '@/pages/teacher/exam/detail'
              )
          },
          {
            path: 'teacher-exam-demo-compose',
            name: 'TeacherExamDemoCompose',
            meta: { excludeHeader: true },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-store-demo-compose" */ '@/pages/teacher/exam/compose/demo/index.vue'
              )
          },
          {
            path: 'teacher-exam-demo-upload',
            name: 'TeacherExamDemoUpload',
            meta: { excludeHeader: true },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-store-demo-upload" */ '@/pages/teacher/exam/upload/demo/index.vue'
              )
          },
          {
            path: 'compose',
            name: 'TeacherExamCompose',
            meta: {
              excludeHeader: true,
              helpID: '20256'
            },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-store-compose" */ '@/pages/teacher/exam/compose'
              )
          },
          {
            path: 'shared',
            name: 'TeacherExamShare',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-store-share" */ '@/pages/teacher/exam/share'
              )
          }
        ]
      },

      // Kiểm tra
      {
        path: 'exam-period', // Màn kiểm tra  - CreateBy: NVDuc 08.08
        name: 'TeacherExamPeriod',
        component: () =>
          import(
            /* webpackChunkName: "teacher-exam-period" */ '@/pages/teacher/exam-period'
          ),
        meta: {
        },
        children: [
          {
            path: '',
            name: 'ExamPeriodList  ',
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "exam-period-list" */ '@/pages/teacher/exam-period/list'
              )
          },
          {
            path: 'list-exam',
            name: 'ExamPeriodListInSchool',
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "exam-period-list" */ '@/pages/teacher/exam-period/list-in-school'
              )
          },
          {
            path: 'list-exam-store',
            name: 'ExamStoreListInSchool',
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "exam-period-list" */ '@/pages/teacher/exam-period/list-exam-store'
              )
          },

          {
            path: 'create',
            name: 'ExamPeriodCreate',
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "exam-period-create" */ '@/pages/teacher/exam-period/create'
              )
          },
          {
            path: ':examPeriodId',
            name: 'TeacherExamPeriodDetailDot',
            props: true,
            meta: {
              excludeHeader: true,
              groupType: 'DocumentTest',
              bussinessType: 'DocumentTest_Detail'
            },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-period-detail" */ '@/pages/teacher/exam-period/detail'
              )
          },
          {
            path: 'teacher-exam-period/:examPeriodId',
            name: 'TeacherExamPeriodDetail',
            props: true,
            meta: {
              excludeHeader: true,
              groupType: 'DocumentTest',
              bussinessType: 'DocumentTest_Detail'
            },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-period-detail" */ '@/pages/teacher/exam-period/detail-v2'
              )
          },
          {
            path: 'detail/:examPeriodId',
            name: 'ExamPeriodDetail',
            props: true,
            meta: {
              excludeHeader: true,
              groupType: 'DocumentTest',
              bussinessType: 'DocumentTest_Detail'
            },
            component: () =>
              import(
                /* webpackChunkName: "teacher-exam-period-detail" */ '@/pages/teacher/exam-period/detail-v2'
              )
          },
          {
            path: ':examPeriodId/:studentExamId',
            name: 'TeacherCorrectStudentExam',
            meta: { excludeHeader: true },
            component: () =>
              import(
                /* webpackChunkName: "teacher-correct-student-exam" */ '@/pages/teacher/exam-period/correct'
              )
          },
          {
            path: 'participant',
            name: 'ExamPeriodParticipant',
            meta: { excludeHeader: true },
            component: () =>
              import(
                /* webpackChunkName: "exam-period-participant" */ '@/pages/teacher/exam-period/participant'
              )
          }
        ]
      },
      // Kỳ đánh giá
      {
        path: 'school-exam-period',
        name: 'TeacherSchoolExamPeriod',
        component: () =>
          import(
            /* webpackChunkName: "teacher-school-exam-period" */ '@/pages/teacher/school-exam-period'
          ),
        meta: {
          groupType: 'AssessmentPeriod',
          bussinessType: 'AssessmentPeriod_List',
          title: TitleConst.Exam,
          isExam: true
        },
        children: [
          {
            path: '',
            name: 'dashboard',
            meta: {
              helpID: null
            },
            component: () =>
              import(
                /* webpackChunkName: "school-exam-period-list" */ '@/pages/teacher/school-exam-period/dash-board'
              )
          },
          {
            path: 'list',
            name: 'AssessmentPeriodList',
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "school-exam-period-list-v2" */ '@/pages/teacher/school-exam-period/list/router-view'
              ),
            children: [
              {
                path: '',
                name: 'AssessmentList',
                meta: {
                  groupType: 'AssessmentPeriods',
                  bussinessType: 'AssessmentPeriod_ListAssessment',
                  excludeHeader: true
                },
                component: () =>
                  import(
                  /* webpackChunkName: "school-exam-period-list-v2" */ '@/pages/teacher/school-exam-period/list'
                  )
              },
              {
                path: 'overview',
                name: 'AssessmentPeriodOverview',
                meta: {
                  groupType: 'AssessmentPeriods',
                  bussinessType: 'AssessmentPeriod_ListOverview',
                  excludeHeader: true
                },
                component: () =>
                  import(
                    /* webpackChunkName: "school-exam-period-list-overview" */ '@/pages/teacher/school-exam-period/overview'
                  )
              },
              {
                path: 'compensatory-test',
                name: 'CompensatoryTest',
                meta: {
                  groupType: 'AssessmentPeriods',
                  bussinessType: 'AssessmentPeriod_ListCompensatoryTest',
                  excludeHeader: true
                },
                component: () =>
                  import(
                    /* webpackChunkName: "school-exam-period-list-overview" */ '@/pages/teacher/school-exam-period/overview'
                  )
              },
              {
                path: 'marking-progress',
                name: 'AssessmentPeriodMarkingProgress',
                meta: {
                  groupType: 'AssessmentPeriods',
                  bussinessType: 'AssessmentPeriod_ListMarking',
                  excludeHeader: true
                },
                component: () =>
                  import(
                    /* webpackChunkName: "school-exam-period-list-progress" */ '@/pages/teacher/school-exam-period/marking-progress'
                  )
              },
              {
                path: 'detail/:id',
                props: true,
                name: 'TeacherAssessmentDetail',
                component: () =>
                  import(
                    /* webpackChunkName: "teacher-school-exam-period-detail" */ '@/pages/teacher/school-exam-period/detail'
                  ),
                meta: {
                  excludeHeader: true,
                  groupType: 'AssessmentPeriods',
                  bussinessType: 'AssessmentPeriod_DetailExam'
                }
              }
            ]
          },
          {
            path: 'assignment',
            name: 'AssessmentPeriodAssignment',
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "school-exam-period-list-assignment" */ '@/pages/teacher/school-exam-period/assignment'
              )
          },

          {
            path: 'subject', // Màn chi tiết kì kiểm tra 1 khối theo môn  - CreateBy: VHSon 31.08
            name: 'ExamPeriodDetailBySubject',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "detail-subject" */ '@/pages/teacher/school-exam-period/detail-subject'
              )
          }
        ]
      },

      /**
       * Quản lý lớp học trực tuyến
       */
      {
        path: 'online-classroom',
        name: 'TeacherOnlineClassroom',
        meta: {
          helpID: '20222'
        },
        component: () =>
          import(
            /* webpackChunkName: "teacher-online-classroom" */ '@/pages/teacher/online-classroom'
          ),

        children: [
          {
            path: '',
            name: 'TeacherSetupClassroom',
            component: () =>
              import(
                /* webpackChunkName: "teacher-setup-classroom" */ '@/pages/teacher/online-classroom/setup-classroom'
              ),
            meta: {
              isEventCalendar: true,
              isNotShowNavigation: true,
              groupType: 'RoomEMIS',
              bussinessType: 'RoomEMIS_SetUpClassroom'
            }
          },

          {
            path: 'install-zoom',
            name: 'TeacherInstallZoom',
            component: () =>
              import(
                /* webpackChunkName: "teacher-install-zoom" */ '@/pages/teacher/online-classroom/setup-classroom'
              ),
            meta: {
              isEventCalendar: true,
              isNotShowNavigation: true,
              groupType: 'RoomEMIS',
              bussinessType: 'RoomEMIS_SetUpClassroom'
            }
          },
          {
            path: ':screenMode',
            name: 'TeacherSetupClassroomByMode',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "teacher-setup-classroom-by-mode" */ '@/pages/teacher/online-classroom/setup-classroom'
              ),
            meta: {
              isEventCalendar: true,
              isNotShowNavigation: true
            }
          },

          {
            path: 'zoom-meetings',
            name: 'ZoomMeetings',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "zoom-meetings" */ '@/pages/teacher/online-classroom/zoom-meetings'
              ),
            meta: {
              isEventCalendar: true,
              isNotShowNavigation: true
            }
          },

          {
            path: 'google-meet',
            name: 'GoogleMeet',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "google-meet" */ '@/pages/teacher/online-classroom/google-meet'
              ),
            meta: {
              isEventCalendar: true,
              isNotShowNavigation: true
            }
          },

          {
            path: 'list-calendar',
            name: 'TeacherListCalendar',
            component: () =>
              import(
                /* webpackChunkName: "teacher-list-calendar" */ '@/pages/teacher/online-classroom/list-calendar'
              ),
            meta: {
              isEventCalendar: true,
              groupType: 'RoomEMIS',
              bussinessType: 'RoomEMIS_CalendarList'
            }
          },
          {
            path: 'manage-calendar',
            name: 'TeacherManageCalendar',
            component: () =>
              import(
                /* webpackChunkName: "teacher-manage-calendar" */ '@/pages/teacher/online-classroom/manage-calendar'
              ),
            meta: {
              isEventCalendar: true,
              groupType: 'RoomEMIS',
              bussinessType: 'RoomEMIS_ManageCalendar'
            }
          }
        ]
      }
    ]
  },

  // Student routes
  {
    path: '/student',
    name: 'Student',
    component: PageIndex,
    children: [
      // {
      //   path: 'video-hocmai',
      //   name: 'Video',
      //   meta: {
      //     ignoreAuth: true
      //   },
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "video" */ '../pages/student/video-hocmai'
      //     )
      // },

      // Tổng quan
      {
        path: 'dashboard',
        alias: '',
        name: 'StudentDashboard',
        component: () =>
          import(
            /* webpackChunkName: "student-dashboard" */ '@/pages/student/dashboard'
          ),
        children: [
          {
            path: '',
            name: 'StudentDashboardOverview',
            meta: {
              groupType: 'DashBoard',
              bussinessType: 'DashBoard_OverView',
              helpID: '17889'
            },
            component: () =>
              import(
                /* webpackChunkName: "student-dashboard-overview" */ '@/pages/student/dashboard/overview'
              )
          }
        ]
      },

      // lớp học của học sinh
      {
        path: 'classroom',
        name: 'StudentClassRoom',
        component: () =>
          import(
            /* webpackChunkName: "student-classroom" */ '@/pages/student/classroom/'
          ),

        children: [
          {
            path: '',
            name: 'StudentClassList',
            meta: {
              groupType: 'Learning',
              bussinessType: 'Learning_Classroom',
              helpID: '16519'
            },
            component: () =>
              import(
                /* webpackChunkName: "student-class-list" */ '@/pages/student/classroom/list'
              )
          },
          {
            path: 'list-wait-approve',
            name: 'StudentClassListWaitApprove',
            meta: {
              groupType: 'Learning',
              bussinessType: 'Learning_ClassApprove'
            },
            component: () =>
              import(
                /* webpackChunkName: "student-class-list-wait-approve" */ '@/pages/student/classroom/list-wait-approve'
              )
          },
          {
            path: ':classCode',
            name: 'ClassroomExercise',
            component: () =>
              import(
                /* webpackChunkName: "classroom-exercise" */ '@/pages/student/classroom/exercises'
              ),
            redirect: (to) => {
              return {
                path: `${to.path}/exercise`
              }
            },
            props: true,
            children: [
              {
                path: 'friendly',
                name: 'FriendList',
                props: true,
                meta: {
                  groupType: 'Learning',
                  bussinessType: 'Learning_Classmate'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "student-list" */ '@/pages/student/classroom/friendly'
                  )
              },
              {
                path: 'exercise',
                name: 'TeacherClassDetailExercise',
                component: () =>
                  import(
                    /* webpackChunkName: "exercise-list" */ '@/pages/student/classroom/exercises/exercise-grid'
                  ),
                children: [
                  {
                    path: '',
                    name: 'TeacherClassDetailExercise',
                    meta: {
                      groupType: 'Learning',
                      bussinessType: 'Learning_Excercise'
                    },
                    component: () =>
                      import(
                        /* webpackChunkName: "exercise-list" */ '@/pages/student/classroom/exercises/classroom-exercises'
                      )
                  }
                ]
              },
              {
                path: 'partner-exercise',
                name: 'PartnerExercise',
                component: () =>
                  import(
                    /* webpackChunkName: "partner-exercise" */ '@/pages/student/classroom/partner-exercise'
                  )
              },
              {
                path: 'storage',
                name: 'ClassroomStorageExercise',
                props: true,
                meta: {
                  groupType: 'Learning',
                  bussinessType: 'DocumentStore_List_Refer'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "storage-classroom" */ '@/pages/student/classroom/storage-exercise'
                  )
              }
            ]
          },
          {
            path: 'join-classroom/:classCode',
            name: 'StudentJoinInviteClassroom',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "student-join-invite-classroom" */ '@/pages/student/classroom/join-classroom'
              )
          }

        ]
      },

      // Màn hình bài tập
      {
        path: 'exercise', // Màn hình bài tập
        name: 'Exercise',
        component: () =>
          import(
            /* webpackChunkName: "exercise" */ '@/pages/student/exercises'
          ),

        children: [
          {
            path: 'refer',
            name: 'ListRefer',
            meta: {
              groupType: 'Learning',
              bussinessType: 'Learning_ExcerciseRefer'
            },
            component: () =>
              import(
                /* webpackChunkName: "list-refer" */ '@/pages/student/exercises/refer-exercise'
              ),
            children: [
              {
                path: 'detail',
                name: 'ReferExercise',
                component: () =>
                  import(
                    /* webpackChunkName: "refer-exercise" */ '@/pages/student/classroom/exercises/exercise-detail'
                  )
              }
            ]
          },

          {
            path: '',
            name: 'ExerciseListV2',
            meta: {
              groupType: 'Learning',
              bussinessType: 'Learning_Excercise',
              helpID: '19464'
            },
            component: () =>
              import(
                /* webpackChunkName: "exercise-list-v2" */ '@/pages/student/exercises/list-v2'
              )
          },
          // pqhieu
          {
            path: 'overview-layout',
            name: 'OverviewLayout',
            meta: { excludeHeader: true },
            component: () =>
              import(
                /* webpackChunkName: "overview-layout" */ '@/pages/student/exercises/overview-layout'
              )
          },
          {
            path: 'answer',
            name: 'FileUpload',
            meta: {
              excludeHeader: true,
              groupType: 'Learning',
              bussinessType: 'Learning_DoExcercise',
              helpID: '16523'
            },
            component: () =>
              import(
                /* webpackChunkName: "file-upload" */ '@/pages/student/exercises/file-upload'
              )
          },
          {
            path: ':id',
            name: 'InformationExercise',
            component: () =>
              import(
                /* webpackChunkName: "information-exercise" */ '@/pages/student/exercises/detail'
              )
          },
          {
            path: 'start',
            name: 'CreatedExcercises',
            component: () =>
              import(
                /* webpackChunkName: "created-excercises-v2" */ '@/pages/student/exercises/created-exercises-v2'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'theme',
            name: 'ChooseExerciseTheme',
            component: () =>
              import(
                /* webpackChunkName: "choose-exercise-theme" */ '@/pages/student/exercises/choose-exercise-theme'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'preview-answer-upload/:pagePrev/:classCode/:studentExercisesID/:submitExercisesID',
            name: 'StudentPreviewAnswerUpload',
            component: () =>
              import(
                /* webpackChunkName: "preview-answer-upload" */ '@/pages/student/exercises/preview-answer-upload'
              ),
            meta: {
              excludeHeader: true,
              helpID: '19462'
            }
          },
          {
            path: 'answer-overview',
            name: 'AnswerOverview',
            component: () =>
              import(
                /* webpackChunkName: "answer-overview" */ '@/pages/student/exercises/answer-overview-v2'
              ),
            meta: { excludeHeader: true }
          },

          {
            path: 'repair',
            name: 'RepairExercise',
            component: () =>
              import(
                /* webpackChunkName: "repair-exercise" */ '@/pages/student/exercises/repair-exercise'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'print',
            name: 'PrintExercise',
            component: () =>
              import(
                /* webpackChunkName: "print-exercise" */ '@/pages/student/exercises/print-exercise'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'subject',
            name: 'Subject',
            component: () =>
              import(
                /* webpackChunkName: "subject" */ '@/pages/student/exercises/choose-subject'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'game',
            name: 'Game',
            component: () =>
              import(/* webpackChunkName: "game" */ '@/pages/student/game'),

            children: [
              {
                path: 'galactic',
                name: 'Galactic',
                meta: {
                  excludeHeader: true
                },
                component: () =>
                  import(
                    /* webpackChunkName: "galactic" */ '@/pages/student/game/galactic'
                  ),
                children: [
                  {
                    path: '',
                    name: 'GalacticWarrior',
                    component: () =>
                      import(
                        /* webpackChunkName: "galactic-warrior" */ '@/pages/student/game/galactic/overview'
                      )
                  }
                ]
              }
            ]
          }
        ]
      },

      // bắt đầu tham gia lớp học
      {
        path: 'getting-started',
        name: 'GetttingStated',
        component: () =>
          import(
            /* webpackChunkName: "gettting-stated" */ '@/pages/student/getting-started'
          ),
        meta: { excludeHeader: true }
      },

      // Màn hình lịch học
      {
        path: 'meetings',
        name: 'Meeting',
        component: () =>
          import(/* webpackChunkName: "meeting" */ '@/pages/student/meeting'),

        children: [
          {
            path: '',
            name: 'Schedule',
            meta: {
              groupType: 'RoomEMIS',
              bussinessType: 'RoomEMIS_Meetings'
            },
            component: () =>
              import(
                /* webpackChunkName: "schedule" */ '@/pages/student/meeting/schedule'
              )
          }
        ]
      },

      // Màn hình kho học liệu
      {
        path: 'storage-partner',
        name: 'StoragePartner',
        component: () =>
          import(
            /* webpackChunkName: "storage-partner" */ '@/pages/student/storage'
          )
      },

      // Màn hình Học liệu của học sinh
      // CreateBy: Nvduc 14.09
      {
        path: 'storage-exercise', // Màn hình kho - CreateBy: NVDuc 17/05/2021
        name: 'StorageExercise',
        component: () =>
          import(
            /* webpackChunkName: "storage-exercise" */ '@/pages/student/storage-exercise'
          ),
        children: [
          //
          {
            path: 'detail',
            name: 'StorageExerciseDetail',
            props: true,
            meta: {
              groupType: 'DocumentStore',
              bussinessType: 'Practice_Detail_HocMaiCourse',
              excludeHeader: true,
              helpID: '21383'
            },
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-detail" */ '@/pages/student/storage-exercise/detail'
              )
          },
          {
            path: 'detail-outline/hoc-mai/:idDad/:idChil/:courseID/:lessonID',
            name: 'ExerciseDetailOutLineHocMai',
            props: true,
            meta: {
              groupType: 'DocumentStore',
              bussinessType: 'Practice_Detail_HocMaiCourseDetail',
              excludeHeader: true,
              helpID: '21430'
            },
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-detail-outline-hoc-mai" */ '@/pages/student/storage-exercise/detail-outline/hoc-mai'
              )
          },
          {
            path: 'detail-outline/hoc-mai/video',
            name: 'ExerciseDetailOutLineHocMaiVideo',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-detail-outline-hoc-mai-new" */ '@/pages/student/storage-exercise/detail-outline/hoc-mai/video'
              )
          },
          {
            path: 'detail-outline/igiaoduc/:courseID',
            name: 'ExerciseDetailOutLineIGiaoDuc',
            props: true,
            meta: {
              groupType: 'DocumentStore',
              bussinessType: 'Practice_Detail_IGiaoDucCourseDetail'
            },
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-detail-outline-igiaoduc" */ '@/pages/student/storage-exercise/detail-outline/igiaoduc'
              )
          },
          {
            path: 'favorite',
            name: 'StorageExerciseFavorite',
            props: true,
            meta: {
              groupType: 'DocumentStore',
              bussinessType: 'Practice_Detail_IGiaoDucCourse'
            },
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-favorite" */ '@/pages/student/storage-exercise/favorite'
              )
          },
          {
            path: 'start',
            name: 'StorageExerciseStart',
            props: true,
            meta: {
              groupType: 'DocumentStore'
            },
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-detail" */ '@/pages/student/storage-exercise/detail-outline/hoc-mai/created-exercises'
              )
          },

          {
            path: 'self-learning/:sourcePre',
            name: 'StorageExerciseSelfLearning',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-self-learning" */ '@/pages/student/storage-exercise/self-learning'
              )
          },
          {
            path: 'self-learning/course-result',
            name: 'CourseResult',
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(/* webpackChunkName: "course-result" */ '@/views/pages/student/storage-exercise/self-learning/common/result.vue')
          },
          {
            path: 'self-learning/multiple-choice',
            name: 'SelfLearningMultipleChoice',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-multiple-choice" */ '@/pages/student/storage-exercise/answer'
              )
          },
          {
            path: 'theme',
            name: 'Theme',
            props: true,
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "storage-exercise-multiple-choice" */ '@/pages/student/storage-exercise/choose-exercise-theme'
              )
          }
        ]
      },

      // Màn hình giỏ học liệu
      {
        path: 'course-cart',
        alias: '',
        name: 'CourseCart',
        component: () =>
          import(/* webpackChunkName: "course-cart" */ '@/pages/student/storage-exercise/detail-outline/hoc-mai/course-cart'),
        children: [
          {
            path: '',
            name: 'CourseCartList',
            component: () =>
              import(/* webpackChunkName: "course-cart-list" */ '@/pages/student/storage-exercise/detail-outline/hoc-mai/course-cart/course-cart-list')
          },
          {
            path: 'create/:orderId',
            name: 'CreateRegistrationForm',
            component: () =>
              import(
                /* webpackChunkName: "create-registration-form" */ '@/pages/student/storage-exercise/detail-outline/hoc-mai/course-cart/create-registration-form'
              )
          }
        ]
      },
      // File upload test
      {
        path: 'file-test',
        alias: '',
        name: 'File',
        component: () =>
          import(/* webpackChunkName: "file" */ '@/pages/teacher/file'),
        children: []
      },
      // Quản lý hồ sơ
      {
        path: 'profile',
        name: 'Profile',
        component: () =>
          import(/* webpackChunkName: "profile" */ '@/pages/student/profile'),
        children: [
          {
            path: 'general',
            name: 'AccountGeneral',
            meta: {
              groupType: 'System',
              bussinessType: 'System_Account'
            },
            component: () =>
              import(
                /* webpackChunkName: "account-general" */ '@/pages/student/profile/general'
              )
          },
          {
            path: 'achievements',
            name: 'Achievements',
            component: () =>
              import(
                /* webpackChunkName: "achievements" */ '@/pages/student/profile/achievements'
              )
          },
          {
            path: 'archive',
            name: 'Archive',
            component: () =>
              import(
                /* webpackChunkName: "archive" */ '@/pages/student/profile/archive'
              )
          },
          {
            path: 'help',
            name: 'Help',
            component: () =>
              import(
                /* webpackChunkName: "help" */ '@/pages/student/profile/help'
              )
          },
          {
            path: 'exchange-gift',
            name: 'ExchangeGift',
            component: () =>
              import(
                /* webpackChunkName: "exchange-gift" */ '@/pages/student/profile/exchange'
              )
          },
          {
            path: 'detail',
            name: 'ProfileDetail',

            component: () =>
              import(
                /* webpackChunkName: "profile-detail" */ '@/pages/student/profile/profile-detail/index'
              ),
            children: [
              {
                path: 'edit',
                name: 'EditProfile',
                meta: {
                  groupType: 'System',
                  bussinessType: 'System_Profile'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "edit-profile" */ '@/pages/student/profile/profile-detail/profile-detail'
                  )
              },
              {
                path: 'account-info',
                name: 'AccountInfo',
                meta: {
                  groupType: 'System',
                  bussinessType: 'System_Account'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "account-info" */ '@/views/pages/student/profile/account-manage'
                  )
              },
              {
                path: 'change-password',
                name: 'ChangePassword',
                meta: {
                  groupType: 'System',
                  bussinessType: 'System_Changepassword'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "change-password" */ '@/views/pages/student/profile/change-password'
                  )
              },
              {
                path: 'log-activity-student',
                name: 'LogActivityStudent',
                meta: {
                  groupType: 'System',
                  bussinessType: 'System_LogActivityStudent'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "log-activity-student" */ '@/views/pages/student/profile/log-activity-student'
                  )
              },
              {
                path: 'theme-setting',
                name: 'ThemeSetting',
                meta: {
                  groupType: 'System',
                  bussinessType: 'System_ThemeSetting'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "theme-setting" */ '@/views/pages/student/profile/theme-setting'
                  )
              },
              {
                path: 'registration-form',
                name: 'RegistrationForm',
                meta: {
                  groupType: 'System',
                  bussinessType: 'System_RegistrationForm'
                },
                component: () =>
                  import(
                    /* webpackChunkName: "registration-form" */ '@/views/pages/student/profile/registration-form'
                  )
              }
            ]
          }
        ]
      },
      // ôn luyện - làm bt
      {
        path: 'practice',
        name: 'Practice',
        meta: {
          title: TitleConst.Practice,
          helpID: '21763'
        },
        component: () =>
          import(/* webpackChunkName: "practice" */ '@/pages/student/practice'),
        children: [
          {
            path: '',
            name: 'PracticeList',

            component: () =>
              import(
                /* webpackChunkName: "practice-list" */ '@/pages/student/practice/list'
              )
          },
          {
            path: 'favourite',
            name: 'Favourite',
            meta: {
              groupType: 'DocumentStore',
              bussinessType: 'favourite_list'
            },
            component: () =>
              import(
                /* webpackChunkName: "practice-list" */ '@/pages/student/practice/favourite-excercise'
              )
          },
          {
            path: 'detail',
            name: 'PracticeExercise',
            meta: {
              groupType: 'DocumentStore',
              bussinessType: 'Practice_Detail_EMIS'
            },
            component: () =>
              import(
                /* webpackChunkName: "practice-exercise" */ '@/pages/student/practice/practice-detail'
              )
          },
          {
            path: 'theme',
            name: 'ChoosePracticeTheme',
            meta: {
              groupType: 'DocumentStore',
              bussinessType: 'Practice_Detail_EMIS',
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "choose-practice-theme" */ '@/pages/student/practice/choose-exercise-theme'
              )
          },
          {
            path: 'answer',
            name: 'PracticeExerciseUpload',
            meta: {
              excludeHeader: true
            },
            component: () =>
              import(
                /* webpackChunkName: "practice-exercise-upload" */ '@/pages/student/practice/file-upload'
              )
          },

          {
            path: 'start',
            name: 'PracticeExcerciseComposeV2',

            component: () =>
              import(
                /* webpackChunkName: "practice-excercise-compose-v2" */ '@/pages/student/practice/created-exercise-v2'
              ),
            meta: { excludeHeader: true }
          },

          {
            path: 'answer-overview',
            name: 'PracticeAnswerOverviewV2',
            component: () =>
              import(
                /* webpackChunkName: "practice-answer-overview-v2" */ '@/pages/student/practice/answer-overview-v2'
              ),
            meta: { excludeHeader: true }
          },

          {
            path: 'preview-answer-upload',
            name: 'PreviewAnswerUploadPractice',
            component: () =>
              import(
                /* webpackChunkName: "preview-answer-upload-practice" */ '@/pages/student/practice/preview-answer-upload'
              ),
            meta: { excludeHeader: true }
          },

          {
            path: 'print',
            name: 'PrintPracticeExercise',
            component: () =>
              import(
                /* webpackChunkName: "print-practice-exercise" */ '@/pages/student/practice/print-exercise'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'self-training',
            name: 'SelfTraining',
            component: () =>
              import(
                /* webpackChunkName: "SelfTraining" */ '@/pages/student/storage-exercise/detail-outline/hoc-mai/created-exercises'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'compound-exercise',
            name: 'CompoundExercise',
            component: () =>
              import(
                /* webpackChunkName: "compound-exercise" */ '@/pages/student/storage-exercise/detail-outline/hoc-mai/created-exercises-clone'
              ),
            meta: { excludeHeader: true }
          },

          {
            // Kiến thức
            path: 'exercise/:practicePage/:subjectType',
            name: 'PracticeExerciseParent',
            // meta: {
            //   groupType: 'DocumentStore',
            //   bussinessType: 'Practice_Refer'
            // },
            component: () =>
              import(
                /* webpackChunkName: "practice-exercise-parent" */ '@/pages/student/practice/exercise'
              )
          }
        ]
      },

      // Kiểm tra
      {
        path: 'student-exam',
        name: 'Examination',
        meta: {
          title: TitleConst.Exam
        },
        component: () =>
          import(
            /* webpackChunkName: "examination" */ '@/pages/student/examination'
          ),
        children: [
          {
            path: '',
            name: 'ListExamination',
            meta: {
              groupType: 'DocumentTest',
              bussinessType: 'DocumentTest_List',
              helpID: '22417'
            },
            component: () =>
              import(
                /* webpackChunkName: "list-examination" */ '@/pages/student/examination/list-examination'
              )
          },
          {
            path: 'do-v2/:id/:teacherExamPeriodID',
            name: 'DoExaminationV2',
            component: () =>
              import(
                /* webpackChunkName: "do-examination-v2" */ '@/pages/student/examination/do-examination-v2'
              ),
            meta: { excludeHeader: true }
          },

          {
            path: 'do/:id/:teacherExamPeriodID',
            name: 'DoExamination',
            component: () =>
              import(
                /* webpackChunkName: "do-examination" */ '@/pages/student/examination/do-examination'
              ),
            meta: { excludeHeader: true }
          },

          {
            path: 'upload-examination/:id/:teacherExamPeriodID',
            name: 'UploadExamination',
            component: () =>
              import(
                /* webpackChunkName: "upload-examination" */ '@/pages/student/examination/upload-examination'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: 'questions/:id/:teacherExamPeriodID',
            name: 'QuestionsExamination',
            component: () =>
              import(
                /* webpackChunkName: "questions-examination" */ '@/pages/student/examination/questions-examination'
              ),
            meta: { excludeHeader: true }
          },
          {
            path: '',
            name: 'Result',
            component: () =>
              import(
                /* webpackChunkName: "result" */ '@/pages/student/examination/result/'
              ),
            children: [
              {
                path: 'submit-successful/:id',
                name: 'SubmitSuccesful',
                component: () =>
                  import(
                    /* webpackChunkName: "submit-successful" */ '@/pages/student/examination/result/submit-successful'
                  )
              },
              {
                path: 'result/:id',
                name: 'OverallResult',
                component: () =>
                  import(
                    /* webpackChunkName: "overall-result" */ '@/pages/student/examination/result/overall-result'
                  )
              },
              {
                path: 'review/:id/:examPeriodID',
                name: 'ResultReview',
                component: () =>
                  import(
                    /* webpackChunkName: "result-review" */ '@/pages/student/examination/result/result-review'
                  )
              }
            ]
          },
          {
            path: 'ready/:examPeriodID',
            name: 'StudentExamReady',
            component: () =>
              import(
                /* webpackChunkName: "questions-examination" */ '@/pages/student/examination/ready'
              )
            // meta: { excludeHeader: true }
          }
        ]
      }
    ]
  },
  {
    path: '/control',
    name: 'Control',
    meta: {
      ignoreAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "control" */ '../pages/common/control')
  },
  {
    path: '/control/gg-drive',
    name: 'ControlGgDrive',
    meta: {
      ignoreAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "control-gg" */ '../pages/common/control/google-drive-file'
      )
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: {
      ignoreAuth: true
    },
    component: NotFound
  }
]

const baseUrl =
  process.env.NODE_ENV !== 'development' ? window.__env.base_router : '/'

const router = createRouter({
  history: createWebHistory(baseUrl),
  scrollBehavior: function (to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let scrollBehavior = {
          behavior: 'smooth'
        }
        let additionBehavior = {}

        if (to.hash) {
          additionBehavior.el = to.hash
        } else {
          if (savedPosition) {
            additionBehavior = { ...savedPosition }
          } else {
            additionBehavior = { left: 0, top: 0 }
          }
        }
        scrollBehavior = { ...additionBehavior, ...scrollBehavior }

        resolve(scrollBehavior)
      }, 500)
    })
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => !record.meta.ignoreAuth)) {
    const token = getAuthToken()

    if (!token) {
      redirectToLogin()
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  nextTick(() => {
    setTitle(to.meta.title)
  })
})

export default router
